export const basePath = process.env.NODE_ENV === 'local' ? process.env.BASE_URL : process.env.VUE_APP_URL